export default __webpack_public_path__ + "static/media/cert-finance-HKIRC.d108ad9a.jpg";